import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import header_logo from "../../Assets/header_logo.webp";

const Header = () => {
  const toggleMenu = () => {
    const menu = document.getElementById("navbarContent");
    if (menu.classList.contains("show")) {
      menu.classList.remove("show");
    } else {
      menu.classList.add("show");
    }
  };

  return (
    <header className="container-fluid header_section">
      <nav className="navbar navbar-expand-lg sticky-top">
        <div className="container-fluid">
          <Link className="headerlogo" to="/">
            <img src={header_logo} alt="Logo" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  HOME
                </Link>
              </li>
             {/*  <li className="nav-item">
                <Link className="nav-link" to="/AboutUs">
                  ABOUT
                </Link>
              </li> */}

              <li className="nav-item dropdown">
                <Link className="nav-link" to="/AboutUs">
                  <span className="nav-link dropdown-toggle" role="button">
                    ABOUT
                  </span>
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/AboutUs" className="dropdown-item">
                      - Overview
                    </Link>
                  </li>
                  <li>
                    <Link to="/Director_message" className="dropdown-item">
                      - Director Message
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Vision_mission"
                      className="dropdown-item"
                    >
                      - Vision & Mission
                    </Link>
                  </li>
                  <li>
                    <Link to="/Our_strength" className="dropdown-item">
                      - Our Strengths
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Our_value"
                      className="dropdown-item"
                    >
                      - Our Value
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Principle_of_conduct"
                      className="dropdown-item"
                    >
                      - Principles of Conduct
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Award_media"
                      className="dropdown-item"
                    >
                      - Award , Media & Certificate
                    </Link>
                  </li>
                </ul>
              </li>

              {/* <li className="nav-item">
                <Link className="nav-link" to="/Product">
                  PRODUCTS
                </Link>
              </li> */}

              <li className="nav-item dropdown">
                <Link className="nav-link" to="/Product">
                  <span className="nav-link dropdown-toggle" role="button">
                    PRODUCTS
                  </span>
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/Automotive_Railway_window_glass" className="dropdown-item">
                      - Automotive & Railway Window Glass
                    </Link>
                  </li>
                  <li>
                    <Link to="/Car_Glass" className="dropdown-item">
                      - Car Glass
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/E_Rickshaw_Spare_Parts_Glass"
                      className="dropdown-item"
                    >
                      - E Rickshaw Glass
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/Automotive_Glass" className="dropdown-item">
                      - Automotive Glass
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/Commercial_Vehicle_Glass"
                      className="dropdown-item"
                    >
                      - Commercial Vehicle Glass
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Automobile_Toughness_Glass"
                      className="dropdown-item"
                    >
                      - Automotive Toughened Glass
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/Construction_Equipment_Glass"
                      className="dropdown-item"
                    >
                      - Road & Construction Equipment Glass
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/Automative_Laminated_Glass"
                      className="dropdown-item"
                    >
                      - Automotive Laminated Glass
                    </Link>
                  </li>

                  <li>
                    <Link to="/Arctitecture_Glass" className="dropdown-item">
                      - Arctitecture Glass
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/Home_Appliance_glasses"
                      className="dropdown-item"
                    >
                      - Home Appliance & General Street glasses
                    </Link>
                  </li>

                  {/* <li>
                    <Link to="/Railway_Window_Glass" className="dropdown-item">
                      - Railway Window Glass
                    </Link>
                  </li> */}

                  <li>
                    <Link to="/DGU_Glass" className="dropdown-item">
                      - DGU Glass
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Request_A_Quote">
                  REQUEST A QUOTE
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Faq">
                  FAQs
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/ContactUs">
                  CONTACT US
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
